import { parseJson, renderTpl } from '@/common/utils';
import { resvDataByKey } from '@/office/utils/ejs-util';

// view item

/**
 *
 * @param {setting.ViewItem['font']} font
 * @returns
 */
export const getViewItemFontStyle = (font) => {
  if (!font) return '';
  const { weight, size, color } = font;
  return `font-weight: ${weight ?? 'normal'}; font-size: ${size}px; color: ${color};`;
};

/**
 *
 * @param {setting.ViewItem[]} setting
 * @param {*} ejsScheme
 * @returns
 */
export const compileResvView = (setting, ejsScheme) => {
  const details = [];

  for (const { width, label, content, condition, font } of setting) {
    if (condition != undefined) {
      const condEvalRaw = renderTpl(condition.value, ejsScheme, 'true');
      const condEval = parseJson(condEvalRaw, condEvalRaw);
      if (!condEval) {
        if (condition.type == 1)
          details.push({ label: undefined, viewWidth: width });
        continue;
      }
    }
    const labelEval =
      label.type == 1 ? label.value : renderTpl(label.value, ejsScheme, '');

    const contentTpl = content.type == 1
      ? resvDataByKey[content.value]?.ejs
      : content.value;
    const contentEval = renderTpl(contentTpl, ejsScheme, '');

    const detail = {
      label: labelEval,
      value: contentEval,
      viewWidth: width,
    };
    if (font != undefined) {
      detail.style = getViewItemFontStyle(font);
    }

    details.push(detail);
  }
  return details;
};

// apo text

/**
 *
 * @param {string} text
 * @param {number} maxLen
 * @param {string} type
 * @returns
 */
const adjustText = (text, maxLen, type) => {
  let result = text;
  if (!isNaN(maxLen)) {
    if (Number(maxLen) < text.length) {
      result = text.slice(0, Number(maxLen));
    }
  }
  return adjustTypeText(result, type);
};

/**
 *
 * @param {string} text
 * @param {string} type
 * @returns
 */
const adjustTypeText = (text, type) => {
  if (type == '1') {
    return `(${text})`;
  }
  return text;
};

export const getGeneratedTextByLabel = (dResv, content, context) => {
  const { label, type } = content;
  const {
    resvLabelMap,
    resvLabels,
    maxLen,
    shop,
    shopsByPrefix
  } = context;
  const priceTotal = dResv['priceTotal'];

  if (!resvLabels.includes(label)) {
    return undefined;
  }
  const key = resvLabelMap[label];
  const value = dResv[key];

  switch (label) {
    case '顧客名':
      if (dResv.user?.name) {
        return adjustText(dResv.user.name, maxLen, type);
      }
      break;
    case '顧客電話番号下4桁':
      if (dResv.user?.phoneList) {
        const phoneList = dResv.user?.phoneList.split(',');
        const phone = phoneList[0] || '';
        const phoneLast4 = 4 < phone.length ? phone.slice(-4) : '';
        return adjustText(phoneLast4, maxLen, type);
      }
      break;
    case '顧客会員番号':
      if (dResv.user?.midList) {
        const midList = dResv.user?.midList
          ? dResv.user?.midList.split(',')
          : [];
        const shopMidList = Object.keys(shopsByPrefix).map((prefix) => {
          return {
            prefix: prefix,
            mid: midList.find((mid) => mid.startsWith(prefix)) || '',
          };
        });
        const targetShopMid =
          shopMidList.find((m) => m.prefix == shop?.midPrefix)?.mid || '';
        return adjustText(targetShopMid, maxLen, type);
      }
      break;
    case '釣銭用前渡金':
      if (value != null && value !== '' && !isNaN(value)) {
        if (Number(value) !== 0) {
          return adjustTypeText(`¥${Number(value).toLocaleString()}`, type);
        }
      }
      break;
    case '料金総額':
      if (priceTotal != null && priceTotal !== '' && !isNaN(priceTotal)) {
        if (Number(priceTotal) !== 0) {
          return adjustTypeText(
            `¥${Number(priceTotal).toLocaleString()}`,
            type
          );
        }
      }
      break;
    case 'お店負担':
      if (dResv.burden && dResv.burden.label && !isNaN(dResv.burden.label)) {
        return adjustTypeText(
          `¥${(Number(dResv.burden.label)).toLocaleString()}`,
          type
        );
      }
      break;
    case '料金総額＋カード手数料':
      if (priceTotal != null && priceTotal !== '' && !isNaN(priceTotal)) {
        if (value != null && value !== '' && !isNaN(value)) {
          if (0 < Number(value)) {
            return adjustTypeText(
              `¥${(Number(priceTotal) + Number(value)).toLocaleString()}`,
              type
            );
          } else {
            return adjustTypeText(
              `¥${Number(priceTotal).toLocaleString()}`,
              type
            );
          }
        } else {
          return adjustTypeText(
            `¥${Number(priceTotal).toLocaleString()}`,
            type
          );
        }
      }
      break;
    case '店舗名':
      if (dResv.shopName) {
        return adjustText(dResv.shopName, maxLen, type);
      }
      break;
    case '送りﾄﾞﾗｲﾊﾞｰ':
      if (dResv.driver1.name) {
        return adjustText(dResv.driver1.name, maxLen, type);
      }
      break;
    case '迎えﾄﾞﾗｲﾊﾞｰ':
      if (dResv.driver2.name) {
        return adjustText(dResv.driver2.name, maxLen, type);
      }
      break;
    case '作成者':
      if (dResv.staffCreate.name) {
        return adjustText(dResv.staffCreate.name, maxLen, type);
      }
      break;
    case '受領スタッフ':
      if (dResv.staffRecv.name) {
        return adjustText(dResv.staffRecv.name, maxLen, type);
      }
      break;
    case 'メモ':
      if (dResv.memo) {
        return adjustText(dResv.memo, maxLen, type);
      }
      break;
    case 'ホテル': {
      let hotels = [];
      let n = 1;
      let k = key;
      while (k in dResv) {
        if (dResv[k]?.label) {
          hotels.push(dResv[k]?.label);
        }
        n += 1;
        k = key + n.toString();
      }
      const hotel = hotels.join(',');
      if (hotel != null && hotel !== '') {
        return adjustText(hotel, maxLen, type);
      }
      break;
    }
    case 'ホテルもしくは顧客住所': {
      let hotels = [];
      let n = 1;
      let k = 'hotel';
      while (k in dResv) {
        if (dResv[k]?.label) {
          hotels.push(dResv[k]?.label);
        }
        n += 1;
        k = key + n.toString();
      }
      const hotelName = hotels.join(',');
      const addr1 = dResv.user?.addr1 ?? '';
      const addr2 = dResv.user?.addr2 ?? '';
      let addr = `自宅：${addr1}`;
      if (addr2) {
        addr += ` ${addr2}`;
      }
      const hotelOrUserAddr = hotelName.includes('自宅')
        ? addr.trim()
        : hotelName;
      return adjustText(hotelOrUserAddr, maxLen, type);
    }
    case '顧客の利用回数': {
      const uo = dResv.userOffice;
      if (uo == null) {
        return adjustText('利用0回(ｷｬﾝｾﾙ0回)', maxLen, type);
      }
      return adjustText(`利用${uo.cntNormal ?? 0}回(ｷｬﾝｾﾙ${(uo.cntCancel ?? 0) + (uo.cntCancelBad ?? 0)}回)`, 30, type);
    }
    case '女子の顧客メモ': {
      const himeUser = dResv.himeUser;
      if (himeUser == null) {
        return adjustText('', maxLen, type);
      }
      return adjustText(himeUser.memo ?? '', 10, type);
    }
    case '女子向けメモ': {
      const uo = dResv.userOffice;
      if (uo == null) {
        return adjustText('', maxLen, type);
      }
      return adjustText(uo.himeMemo ?? '', 10, type);
    }
    default: {
      if (value != null && value !== '' && value.label != null) {
        return adjustText(value.label, maxLen, type);
      }
      break;
    }
  }
  return undefined;
};
